export const GET_USER_LOADING = "loading";
export const GET_USER_SUCCESS = "success";
export const GET_USER_ERROR = "error";
